module.exports = __webpack_public_path__ + "img/file6.3d5c7dd2.png";